const DeleteOutlined = ({ size = "23", color = "#959FAF", style = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 28"
    fill="none"
    style={{ ...style }}
  >
    <path
      d="M9.47217 12.45V20.7M14.9722 12.45V20.7M1.22217 6.94995H23.2222M21.8472 6.94995L20.655 23.6452C20.6057 24.339 20.2952 24.9883 19.7862 25.4624C19.2772 25.9364 18.6075 26.2 17.9119 26.2H6.53242C5.83686 26.2 5.16713 25.9364 4.65814 25.4624C4.14914 24.9883 3.83868 24.339 3.78929 23.6452L2.59717 6.94995H21.8472ZM16.3472 6.94995V2.82495C16.3472 2.46028 16.2023 2.11054 15.9444 1.85268C15.6866 1.59482 15.3368 1.44995 14.9722 1.44995H9.47217C9.1075 1.44995 8.75776 1.59482 8.4999 1.85268C8.24203 2.11054 8.09717 2.46028 8.09717 2.82495V6.94995H16.3472Z"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default DeleteOutlined;
